import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
} from '@chakra-ui/react';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const TermsPage: React.FC = () => {
  const { t } = useTranslation();

  const sections = [
    { title: t('landing.termsSectionServiceTitle'), body: t('landing.termsSectionServiceBody') },
    { title: t('landing.termsSectionAccountsTitle'), body: t('landing.termsSectionAccountsBody') },
    { title: t('landing.termsSectionAcceptableUseTitle'), body: t('landing.termsSectionAcceptableUseBody') },
    { title: t('landing.termsSectionUploadedContentTitle'), body: t('landing.termsSectionUploadedContentBody') },
    { title: t('landing.termsSectionSubscriptionBillingTitle'), body: t('landing.termsSectionSubscriptionBillingBody') },
    { title: t('landing.termsSectionFreeTrialTitle'), body: t('landing.termsSectionFreeTrialBody') },
    { title: t('landing.termsSectionAvailabilityTitle'), body: t('landing.termsSectionAvailabilityBody') },
    { title: t('landing.termsSectionIntellectualPropertyTitle'), body: t('landing.termsSectionIntellectualPropertyBody') },
    { title: t('landing.termsSectionDisclaimerTitle'), body: t('landing.termsSectionDisclaimerBody') },
    { title: t('landing.termsSectionLiabilityTitle'), body: t('landing.termsSectionLiabilityBody') },
    { title: t('landing.termsSectionTerminationTitle'), body: t('landing.termsSectionTerminationBody') },
    { title: t('landing.termsSectionGoverningLawTitle'), body: t('landing.termsSectionGoverningLawBody') },
    { title: t('landing.termsSectionChangesTitle'), body: t('landing.termsSectionChangesBody') },
    { title: t('landing.termsSectionContactTitle'), body: t('landing.termsSectionContactBody') },
  ];

  return (
    <>
      <Helmet>
        <title>{t('landing.termsMetaTitle')}</title>
      </Helmet>

      <Box py={16} minH="100vh">
        <Container maxW="3xl">
          <VStack gap={10} align="start">

            {/* Back */}
            <RouterLink to="/" style={{ color: '#3182ce', fontSize: '0.875rem' }}>
              {t('landing.backToHome')}
            </RouterLink>

            {/* Header */}
            <VStack gap={2} align="start">
              <Heading as="h1" size="2xl">{t('landing.termsTitle')}</Heading>
              <Text color="gray.500" fontSize="sm">{t('landing.lastUpdatedFebruary2026')}</Text>
            </VStack>

            {/* Intro */}
            <Text fontSize="lg" color="gray.600">
              {t('landing.termsIntro')}
            </Text>

            {/* Sections */}
            {sections.map(({ title, body }) => (
              <VStack key={title} align="start" gap={3} w="full">
                <Heading as="h2" size="md">{title}</Heading>
                <Text color="gray.600" whiteSpace="pre-line">{body}</Text>
              </VStack>
            ))}

          </VStack>
        </Container>
      </Box>
    </>
  );
};

export default TermsPage;
